import * as React from 'react';
import { Field, Formik } from 'formik';
import { ChangeObserver } from '@app/components/React/Labs/ChangeObserver';

interface IMxPropsEditorProps {
    labId: number,
    caseId: number,
    value?: string;
    readonly?: boolean;
    onChange?: (value: string) => void;
}

export const MxPropsEditor: React.FunctionComponent<IMxPropsEditorProps> = (props) => {
    const [bounds, setBounds] = React.useState<{mx: Array<{ prop: number }>}>()

    React.useEffect(() => {
        const parsedValue: Array<number> = props.value ? JSON.parse(props.value) : [];
        const bounds1 = parsedValue.map((val, idx) => { return { prop: val } });
        setBounds({mx: bounds1});
    }, [props.value])

    const LowerUpperTr = (title, path, key?) => <tr key={key}>
        <td>{title}</td>
        <td>
            {props.readonly &&
                <Field name={`${path}.prop`}>
                    {({ field }) => (<div {...field}>{field.value}</div>)}
                </Field>
            }

            {!props.readonly &&
                <Field type="number" name={`${path}.prop`} />
            }
        </td>
    </tr>
    return bounds != null && <div>
        <Formik
            initialValues={{...bounds}}
            enableReinitialize={false}
            validate={values => {
                const errors = {} as any;
                return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
            }}>
            {({ isSubmitting, values }) => (
                <div>
                    <ChangeObserver value={values} onChange={(vals) => { props.onChange && props.onChange(JSON.stringify(vals.mx.map(x=>x.prop))) }} />
                    <table>
                        <tbody>
                            {values?.mx?.map((mx, idx) => LowerUpperTr(idx, `mx[${idx}]`, `mxpropkey${idx}`))}
                        </tbody>
                    </table>
                </div>
            )}
        </Formik>
    </div>
};
